import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sparkles, Package, Calendar, Star, FileText, Newspaper, Home, LogOut, Sparkle, Gift, Heart, Award } from 'lucide-react';

const AdminLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const navItems = [
    { icon: <Home size={20} />, label: 'Dashboard', path: '/admin' },
    { icon: <Package size={20} />, label: 'Parfums', path: '/admin/perfumes' },
    { icon: <Calendar size={20} />, label: 'Rendez-vous', path: '/admin/appointments' },
    { icon: <Gift size={20} />, label: 'Bons cadeaux', path: '/admin/gift-cards' },
    { icon: <Heart size={20} />, label: 'Coaching - Liste d\'attente', path: '/admin/coaching-waitlist' },
    { icon: <Sparkles size={20} />, label: 'Diagnostics', path: '/admin/diagnostics' },
    { icon: <Star size={20} />, label: 'Témoignages', path: '/admin/testimonials' },
    { icon: <Award size={20} />, label: 'Cercle fidélité', path: '/admin/loyalty' },
    { icon: <FileText size={20} />, label: 'Articles', path: '/admin/articles' },
    { icon: <Newspaper size={20} />, label: 'Actualités', path: '/admin/news' },
  ];

  return (
    <div className="min-h-screen bg-[#FDFAF4]">
      {/* Header */}
      <header className="bg-white border-b border-[#B8922A]/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3">
            <img src="/assets/logo-harmony.jpg" alt="Harmony" className="h-12 w-12 rounded-full object-cover" />
            <span
              className="text-2xl font-light text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              Harmony Parfumerie
            </span>
          </Link>
          <div className="flex items-center gap-6">
            <span className="text-sm text-[#332724]">Bonjour, {user?.name}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 text-sm text-[#5C2018] hover:text-[#1E7A6A] transition-colors"
              data-testid="admin-logout"
            >
              <LogOut size={18} />
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-[#B8922A]/20 min-h-screen p-6">
          <nav className="space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-[#1E7A6A] text-[#FDFAF4]'
                    : 'text-[#332724] hover:bg-[#1E7A6A]/10'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.icon}
                <span className="text-sm">{item.label}</span>
              </Link>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-8">
          {title && (
            <h1
              className="text-4xl font-light mb-8 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              {title}
            </h1>
          )}
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
